import styled, { css } from 'styled-components';
import { DownArrowLong } from '@carvana/icons';
import { cvBreakpoint768 } from '@carvana/theme';
import { CartIcon as _CartIcon, Clock } from '@carvana/purchase-icons';

export const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  height: 56px;
  justify-content: space-between;
  left: 0;
  padding: 0 14px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;

  @media (min-width: ${cvBreakpoint768}px) {
    border-radius: 8px;
    justify-content: initial;
    left: initial;
    position: absolute;
    right: 28px;
    top: 24px;
    z-index: 9;
  }

  &.hide {
    display: none;
  }
`;

export const WidgetWrapper = styled.div`
  align-items: center;
  display: flex;
  visibility: ${props => (props.hide ? 'hidden' : 'initial')};
  width: 90px;

  @media (min-width: ${cvBreakpoint768}px) {
    width: initial;
  }
`;

export const Divider = styled.span`
  border-left: 1px dotted ${props => props.theme.carvana.gray.light};
  display: none;
  height: 60%;
  margin: 0 20px;

  @media (min-width: ${cvBreakpoint768}px) {
    display: initial;
  }
`;

export const TextWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const WidgetLabel = styled.p`
  color: ${props => props.theme.carvana.blue.primary};
  font-size: ${props => (props.isMobile ? '12px' : '14px')};
  font-weight: bold;

  @media (min-width: ${cvBreakpoint768}px) {
    color: ${props => props.theme.carvana.gray.dark};
    font-weight: initial;
  }
`;

export const WidgetValue = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 14px;
  font-weight: bold;

  @media (min-width: ${cvBreakpoint768}px) {
    color: ${props => props.theme.carvana.blue.dark};
    font-size: initial;
    min-width: 70px;
  }
`;

export const ArrowBack = styled(DownArrowLong)`
  cursor: pointer;
  transform: rotate(90deg) scale(0.75);

  & > svg > g {
    fill: ${props => props.theme.carvana.blue.primary};
  }
`;

const widgetIcon = css`
  margin-right: 10px;
  width: 18px;

  @media (min-width: ${cvBreakpoint768}px) {
    margin-right: 14px;
  }
`;

export const ClockIcon = styled(Clock)`
  ${widgetIcon}
  transform: scale(1.5);

  & > circle,
  & > path {
    stroke: ${props => props.theme.carvana.blue.primary};

    @media (min-width: ${cvBreakpoint768}px) {
      stroke: ${props => props.theme.carvana.blue.medium};
    }
  }
`;

export const CartIcon = styled(_CartIcon)`
  ${widgetIcon}

  & > path {
    fill: ${props => props.theme.carvana.blue.primary};

    @media (min-width: ${cvBreakpoint768}px) {
      fill: ${props => props.theme.carvana.blue.medium};
    }
  }
`;
